<section class="microsite_main_body">
    <div class="ms_mobile_wrapper">
        <!-- <a href="http://mswipe.com/">
            <img src="./assets/images/logo1.png" srcset="./assets/images/logo1@2x.png 2x" alt="logo">
        </a> -->
        <div class="ms_mob_right_stars">
            <img src="./assets/images/ms_stars.svg" alt="ms_stars">
        </div>
        <div class="ms_left1_top_mob">
            <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-6 col-md-6">
                <div class="microsite_left_section">
                    <div class="mob_logo_wrapper">
                        <!-- <img src="{{micrositeData?.PBLData?.Brand_Url}}" alt="brand-logo"> -->
                    </div>
                    <div class="logo_wrapper">
                        <img src="./assets/images/brand_logo.svg" alt="brand-logo">
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title">
                            Name of the business
                        </div>

                        <div class="payment_popup_wrapper_mob">
                            <div class="popup_details">
                                <div class="pay_title">
                                    Make payment
                                </div>
                                <div class="form_wrapper">
                                    <div class="form_div">
                                        <form>
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="amount" name="amount"
                                                    placeholder="Enter amount" autocomplete="off">
                                            </div>
                                            <button disabled>
                                                Pay now
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="pay_footer">
                                <img src="./assets/images/m_pay_method.svg" alt="" width="190">
                            </div>
                        </div>
                        <div class="ms_subtitle">
                            Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is attributed to an unknown typesetter in the 15th century who is thought to have scrambled parts of Cicero’s De Finibus
                        </div>
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title">
                            Venue
                        </div>
                        <div class="ms_subtitle">
                            <span>
                                Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is
                            </span>
                            <!-- <span>
                                Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is
                            </span>
                            <span>
                                Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in laying out print, graphic or web designs. The passage is
                            </span> -->
                        </div>
                    </div>
                    <div class="ms_map_wrapper">
                        
                        <div id="map" class="map_wrapper"></div>
                        <div class="payment_popup_wrapper">
                            <div class="popup_details">
                                <div class="pay_title">
                                    Payment details
                                </div>
                                <div class="form_wrapper">
                                    <div class="total">
                                        Total
                                    </div>
                                    <div class="form_div">
                                        <form>
                                            <div class="form-group">
                                                <input type="number" class="form-control" id="amount" name="amount"
                                                    placeholder="Enter amount" autocomplete="off" required>
                                            </div>
                                            <button disabled>
                                                Pay now
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div class="pay_footer">
                                <img src="./assets/images/m_pay_method.svg" alt="" width="190">
                            </div>
                        </div>
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title">
                            Timings
                        </div>
                        <div class="ms_subtitle">
                            <span>
                                10:00 Hrs
                            </span>
                            &nbsp; To &nbsp;
                            <span>
                                18:00 Hrs
                            </span>
                        </div>
                    </div>
                    <div class="ms_shop_img_wrapper">
                        <!-- <div class="ms_main_shop_img">
                            <img src="{{micrositeData?.PBLData?.Shop_Image_Inside_Url}}" alt=""
                                (click)="openImg(micrositeData?.PBLData?.Shop_Image_Inside_Url)">
                        </div> -->
                        <div class="ms_more_shop_img">
                            <div class="ms_img_list" (click)="openImg()">
                                <!-- <img src="{{micrositeData?.PBLData?.Shop_Image_Inside_Url}}" alt="" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Inside_Url)"> -->
                            </div>
                            <div class="ms_img_list" (click)="openImg()">
                                <!-- <img src="{{micrositeData?.PBLData?.Shop_Image_Outside_Url}}" alt="" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Outside_Url)"> -->
                            </div>
                            <!-- <div class="ms_img_list">
                                <img src="{{micrositeData?.PBLData?.Shop_Image_Outside_Url}}" alt="" (click)="openImg(micrositeData?.PBLData?.Shop_Image_Outside_Url)">
                            </div> -->
                        </div>
                        <div class="ms_shop_stars">
                            <img src="./assets/images/ms_stars.svg" alt="ms_stars">
                        </div>
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title">
                            Contact Us:
                        </div>
                        <div class="ms_subtitle">
                            <div>
                                <img src="./assets/images/ms_email.svg" alt="email"> <a
                                    href="mailto:xyz@mswipe.com">xyz@mswipe.com</a>
                            </div>
                            <br>
                            <div>
                                <img src="./assets/images/ms_phone.svg" alt="phone">
                                <a href="tel:9876543210">
                                    9876543210
                                </a>
                                <a href="tel:022234567"> /
                                    022234567
                                </a>
                            </div>
                        </div>
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title ms_title_two">
                            Share this on:
                        </div>
                        <div class="ms_subtitle">
                            <a target="_blank" href="#">
                                <img src="./assets/images/ms_fb.svg" alt="facebook">
                            </a>
                            <a target="_blank" href="#">
                                <img src="./assets/images/ms_ln.png" width="32px" alt="whatsapp">
                            </a>
                            <a target="_blank" href="#">
                                <img src="./assets/images/ms_twit.svg" alt="twitter">
                            </a>
                            <a target="_blank" href="#">
                                <img src="./assets/images/ms_insta.svg" alt="instagram">
                            </a>
                        </div>
                    </div>
                    <div class="ms_info_wrapper">
                        <div class="ms_title ms_title_two">
                            Terms & Conditions
                        </div>
                        <div class="ms_subtitle">
                            This is a sample Payment Page created by Mswipe for demo purposes only. Please note that you will not be getting actual registration post the payment. The payment made will be refunded.
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 offset-lg-2 col-md-4 offset-md-2">
                <div class="microsite_right_section">
                    <div class="m_logo_right">
                        Powered by
                        <a href="http://mswipe.com/">
                            <img src="./assets/images/logo1.png" srcset="./assets/images/logo1@2x.png 2x" alt="logo" width="120">
                        </a>
                    </div>

                    <div class="ms_left1_btm">
                        <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
                    </div>
                    <div class="ms_left2_btm">
                        <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
                    </div>
                    <div class="ms_left1_stars">
                        <img src="./assets/images/ms_stars.svg" alt="ms_stars">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="ms_right_btm">
        <img src="./assets/images/ms_bottom_img.svg" alt="ms_graphic">
    </div>
    <div class="ms_right_stars">
        <img src="./assets/images/ms_stars.svg" alt="ms_stars">
    </div>
    <div class="ms_mobile_wrapper">
        Powered by
        <a href="http://mswipe.com/">
            <img src="./assets/images/logo1.png" srcset="./assets/images/logo1@2x.png 2x" alt="logo" width="80">
        </a>
    </div>
</section>

<div class="img_modal_wrapper" [hidden]="!imgModal">
    <div class="close" (click)="openImg()">&times;</div>
    <div class="img_div">
        <img src="./assets/images/shop_image.png" alt="">
    </div>
</div>